/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class CurrencyExchangeConfigurationQueryScope extends models.QueryOperator {
    constructor() {
        super();
        this.setDiscriminator("CurrencyExchangeConfigurationQueryScope");
    }

    getFixupPrototypeFunction() { return CurrencyExchangeConfigurationQueryScope.fixupPrototype; }

    static newInstance(model: Partial<CurrencyExchangeConfigurationQueryScope>): CurrencyExchangeConfigurationQueryScope {
        let obj = Object.assign(new CurrencyExchangeConfigurationQueryScope(), model);
        CurrencyExchangeConfigurationQueryScope.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<CurrencyExchangeConfigurationQueryScope>): CurrencyExchangeConfigurationQueryScope {
        if (!model) return null;
        return CurrencyExchangeConfigurationQueryScope.newInstance(<CurrencyExchangeConfigurationQueryScope> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: CurrencyExchangeConfigurationQueryScope) {
        if (!obj) return;

        models.CurrencyExchangeConfigurationQueryScope.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: CurrencyExchangeConfigurationQueryScope): boolean {
        if (models.QueryOperator.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, CurrencyExchangeConfigurationQueryScope.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Scopes for Currency Exchange Configuration
     */
    scopes: Array<string>;

}
